import React from "react"
import { Carousel } from './Carousel'

export default class CardHolder extends React.Component {
    constructor(props) {
        super(props);
        this.mobileTarget = window.matchMedia("(min-width: 700px)") /* Retain the target so the event listener can be 
            unmounted */
        this.hideTasksListener = event => { // Define the event lister
            if (event.matches) { // Window has gone from desktop to mobile view
                this.setState({
                    mobileView: true,
                })
            } else { // mobile to desktop
                this.setState({
                    mobileView: false,
                })
            }
        }
        this.mobileTarget.addEventListener("change", this.hideTasksListener) /* Add an event listener for showing the
            carousel */
        this.state = {
            mobileView: this.mobileTarget.matches,
        }
    }

    getChildContext() {
        return {numberOfSiblings: this.props.children.length - 1};
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener) 
    }

    render() {
        const numberOfCards = this.props.children.length
        const padding = `${this.props.paddingWidth}px`
        const columnCount =  numberOfCards
        const resize = this.state.mobileView;
        const width = this.props.width
        const numberOfSiblings = numberOfCards - 1;
        const container = <div
                className="card-row"
                style={{
                    width: width,
                }}
            >
                {this.props.children.map( (child, index) =>
                    <div
                        className="card-column"
                        key={`column-${index}`}
                        style={{
                            paddingLeft: padding,
                            width: `calc(${width} - ${padding} * ${numberOfCards}  + ${padding} / ${columnCount})`
                        }}
                    >
                        {React.cloneElement(
                            child,
                            {
                                numberOfSiblings: numberOfSiblings,
                                key: index,
                                ...child.props
                            }
                        )}
                    </div>
                )}
            </div>

        const carousel = <div style={{ width: width }} >
                {React.createElement(Carousel, { id: "generatedCarousel" }, this.props.children)}
            </div>

        return (
            <div class="container-fluid">
                <div class="row">
                    {resize ? (
                        container
                    ) : (
                        <div className="card-row">{carousel}</div>
                    )}
                </div>
            </div>
        )
    }
}

CardHolder.childContextTypes = {
    numberOfSiblings: React.PropTypes.number
}



// WEBPACK FOOTER //
// app/helpers/Cards/CardHolder.jsx